export default "__VITE_ASSET__c023f4d9__"